import {Component, Fragment, h} from "preact";
import {E} from "../../_common/layout";
import {connect} from "react-redux";
import Dropdown from "../../_common/components/dropdown";
import {t} from "../../_i18n";
import {Link} from "react-router-dom";

type Props = {
    onClick: any
}

const orderIdText: {[key:number]:any} = {
    0: 'Nota en el cuestionario',
    1: 'Porcentaje de ciclo finalizado',
    2: 'Fecha inscripción más reciente',
    3: 'Apellidos'
}



class OrderButton extends Component<Props, any> {

    state = {
        orderText: orderIdText[2]
    }

    orderCandidates = (key:number) => {
        this.setState({orderText: orderIdText[key]})
        this.props.onClick(key)
    }

    render = () =>
            <Fragment>
                <E>
                    <Dropdown icon='fal fa-angle-down' textClassName='font-14 t-underline' text={`Por ${this.state.orderText.toLowerCase()}`} position='right'>
                        <div className='dropdown-item__btn p-left p-right'>
                            <E>
                                <div className='text-small translucent m-bottom'>ORDENAR POR:</div>
                                    {Object.keys(orderIdText).map((key:any) =>
                                        <div className='dropdown-item dropdown-item-left'
                                             onClick={() => this.orderCandidates(key)}>
                                             <span className='font-14 m-r'>{orderIdText[key]}</span>
                                        </div>)
                                    }
                            </E>
                        </div>
                    </Dropdown>
                </E>
            </Fragment>
}

const ConnectedView: any = connect(
    ({}:any)=>({}), {})(OrderButton as any);


export default ({...props}: any) =>
    <ConnectedView {...props}/>
;
